import styled from 'styled-components';

export const CommonSpaceHolderStyled = styled.div`
  .card_wrapper {
    width: 100%;
    background: ${(props) => props.theme.color.white};
    box-sizing: border-box;
    border-radius: 8px;
    max-height: 538px;
    padding: 35px 90px 60px;
    margin: 0px auto;
    text-align: center;

    a {
      text-decoration: none;
    }

    .title {
      font-size: 18px;
      font-weight: 700;
    }
    .addmembers {
      width: 200px !important;
      height: 200px !important;
      display: block !important;
      animation: ${(props) => (props?.animate ? 'fadeInDown 1s ease-in-out' : null)};
    }
    p {
      margin: 6px;
      animation: ${(props) => (props?.animate ? 'fadeInUp 1s ease-in-out' : null)};

      &.title {
        font-weight: 700;
        font-size: 22px;
        line-height: 30px;
        text-align: center;
        color: ${(props) => props.theme.text.dark};
      }
      &.subtitle {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: ${(props) => props.theme.text.medium};
        padding-left: 40px;
        padding-right: 40px;
      }
    }

    .homecare-btn,
    .placeholderBtn {
      animation: ${(props) => (props?.animate ? 'fadeInUp 1s ease-in-out' : null)};
    }
  }

  &.bgGrey {
    .card_wrapper {
      background-color: ${(props) => props.theme.sectionBox.bodyBg};
    }
  }

  @media (max-width: 767px) {
    .card_wrapper {
      padding: 110px 0px 90px 0px;

      p {
        margin: 6px;
        &.subtitle {
          padding: 0px;
          font-size: 14px;
          font-weight: 500;
          line-height: 18px;
        }
      }
    }
  }

  @media (max-width: 480px) {
    .card_wrapper {
      padding: 30px 0px 80px 0px;
      p {
        margin: 6px;
        &.subtitle {
          padding: 0px;
          font-size: 14px;
          font-weight: 500;
          line-height: 18px;
        }
      }
    }
  }

  @keyframes fadeInDown {
    0% {
      opacity: 0;
      transform: translateY(-20px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeInUp {
    0% {
      opacity: 0;
      transform: translateY(40px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
